import styled from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";
import { hexToRgba } from "../../../themes/hex-to-rgba";

const SideMenuComponentDefaultBox = styled.div`
    border-radius: 5px;
    background-color: ${({theme}) => theme.colors.background};
`;

const SideMenuComponentCasino777Box = styled(SideMenuComponentDefaultBox)`
    background-color: ${({theme}) => hexToRgba(theme.colors.background, 0.7) };
    box-shadow: 2px 3px 1rem rgba(25, 50, 48, 0.2);
`;

const SideMenuComponentCasinoMrGreenBox = styled(SideMenuComponentDefaultBox)`
    background-color: transparent;
`;

export const SideMenuComponentBox = styledByTheme(SideMenuComponentDefaultBox)
    .forCasino777(SideMenuComponentCasino777Box)
    .forMrGreen(SideMenuComponentCasinoMrGreenBox)
    .apply();


